import { useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './navigation/Navbar';
import VerticalPageNavigation from './navigation/VerticalPageNavigation';

import GlobalNotification from './navigation/GlobalNotification';
import ErrorDialog from './dialogs/ErrorDialog';
import ConfirmationDialog from './dialogs/ConfirmationDialog';
import AlertDialog from './dialogs/AlertDialog';
import { AppContext } from '../providers/AppProvider';

export default function Layout() {
  const appContext = useContext(AppContext);
  const [navVisible, setNavVisible] = useState(true);

  return (
    <div className="agentbox__portal">
      <Navbar />

      <GlobalNotification
        notifications={appContext.globalNotifications}
        onDismiss={appContext.clearGlobalNotification}
      />

      <div className="agentbox__portal__layout">
        <aside>
          <VerticalPageNavigation
            expanded={appContext.menuExtended}
            visible={navVisible}
            onToggleExpand={(v) => appContext.setMenuExtended(v)}
            onToggleVisibility={setNavVisible}
          />
        </aside>

        <main className="agentbox__portal__content">
          <Outlet />
        </main>
      </div>

      {appContext.errorDialogProps && (
        <ErrorDialog
          {...appContext.errorDialogProps}
          onDismiss={() => appContext.setErrorDialogProps(null)}
        />
      )}
      {appContext.confirmationDialogProps && (
        <ConfirmationDialog
          {...appContext.confirmationDialogProps}
          onCancel={() => appContext.setConfirmationDialogProps(null)}
        />
      )}
      {appContext.alertDialogProps && (
        <AlertDialog
          {...appContext.alertDialogProps}
          onDismiss={() => appContext.setAlertDialogProps(null)}
        />
      )}
    </div>
  );
}
